import { Upload } from "lucide-react";
import { Button, Input } from "@ncoder/ui";

interface ErrorAnalysisFormProps {
  errorFile: File | null;
  onFileSelect: (file: File | null) => void;
}

export const ErrorAnalysisForm: React.FC<ErrorAnalysisFormProps> = ({
  errorFile,
  onFileSelect,
}) => (
  <div className="space-y-4 py-4">
    <div className="border-2 border-dashed border-muted-foreground/25 rounded-lg p-6 text-center">
      <Upload className="h-10 w-10 mx-auto mb-4 text-muted-foreground" />
      <div className="space-y-2">
        <p className="text-sm font-medium">Upload error document</p>
        <p className="text-xs text-muted-foreground">
          Supports .txt, .pdf, .doc, .docx, .eml files up to 10MB
        </p>
        <Input
          id="errorFile"
          type="file"
          accept=".txt,.pdf,.doc,.docx,.eml"
          onChange={(e) => onFileSelect(e.target.files?.[0] || null)}
          className="hidden"
        />
        <Button
          variant="outline"
          onClick={() => document.getElementById("errorFile")?.click()}
        >
          Choose File
        </Button>
        {errorFile && (
          <p className="text-sm text-green-600 mt-2">
            Selected: {errorFile.name}
          </p>
        )}
      </div>
    </div>

    <div className="bg-blue-50 dark:bg-blue-950 p-4 rounded-lg">
      <h4 className="font-medium text-blue-900 dark:text-blue-100 mb-2">
        What our AI will analyze:
      </h4>
      <ul className="text-sm text-blue-800 dark:text-blue-200 space-y-1">
        <li>• Error patterns and root causes</li>
        <li>• Suggested solutions and best practices</li>
        <li>• Related Salesforce documentation</li>
        <li>• Prevention strategies</li>
      </ul>
    </div>
  </div>
);
